<template>
  <InfuseSlideInLayout :title="networkProfile?.name" :parent-to="{ name: 'network-profiles', query: route.query }">
    <template #header>
      <h1 class="text-xl font-bold text-neutral-700">
        <span>{{ networkProfile?.name }}</span>
      </h1>
    </template>

    <InfuseRouterTabLayout v-if="networkProfile" :model="networkProfile" @reload-model="refresh" />
    <InfuseSpinner v-else class="flex items-center justify-center p-16" size="medium" />
  </InfuseSlideInLayout>
</template>

<script setup lang="ts">
import { InfuseRouterTabLayout, InfuseSlideInLayout } from '@infuse/ui/layouts';
import { computed, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useNetworkProfile } from '@infuse/e-connector/network-profile/queries';
import { useRedirectOnNotFound } from '@infuse/e-connector/shared/composables';
import { InfuseSpinner } from '@infuse/ui/components';

const route = useRoute();
const id = computed(() => route.params.id?.toString());

const { networkProfile, fetchNetworkProfileId, isError, error } = useNetworkProfile();
useRedirectOnNotFound(isError, error);

watch(id, () => (fetchNetworkProfileId.value = id.value), { immediate: true });

async function refresh() {
  fetchNetworkProfileId.value = id.value;
}
</script>
